export const timeFormatter = (minutes) => {
  let response = "";
  if (minutes !== null && minutes > 0) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    hours !== 0 ? response = `${hours < 10 ? "0" + hours : hours}с :${remainingMinutes < 10 ? "0" + remainingMinutes : remainingMinutes
      }м ` : response = `${remainingMinutes < 10 ? "0" + remainingMinutes : remainingMinutes
      }м `;
  } else {
    response = "-";
  }
  return response;
};
